import React from 'react';

const SectionBulkActions = ({ selectedSections = [], onDelete, onActivate, onDeactivate }) => {
  if (!selectedSections.length) return null;

  return (
    <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
      <button onClick={() => onActivate(selectedSections)} disabled={!selectedSections.length}>
        Ativar
      </button>
      <button onClick={() => onDeactivate(selectedSections)} disabled={!selectedSections.length}>
        Desativar
      </button>
      <button onClick={() => onDelete(selectedSections)} disabled={!selectedSections.length} style={{ color: 'red' }}>
        Excluir
      </button>
    </div>
  );
};

export default SectionBulkActions;
